import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const devicesConfigService = {
  _url: `${process.env.REACT_APP_CONFIG_API_URL}`,

  GetDevicesConfigLogs(searchQuery, fetch) {
    const [logs, setLogs] = useState({
      logs: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);

    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getDevicesConfigLogs(searchQuery))
        .then(res => {
          setLogs(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery?.page, searchQuery?.pageSize, fetch]);

    return {
      devices_config_logs_loading: status === STATUS.LOADING,
      devices_config_logs_error: status === STATUS.ERROR ? status : '',
      devices_config_logs_data: logs,
    };
  },

  GetActiveDevices(searchQuery) {
    const [devices, setDevices] = useState({
      devices: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);

    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getActiveDevices(searchQuery))
        .then(res => {
          setDevices(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery?.page, searchQuery?.pageSize]);

    return {
      active_devices_loading: status === STATUS.LOADING,
      active_devices_error: status === STATUS.ERROR ? status : '',
      active_devices_data: devices,
    };
  },

  async getDevicesConfigLogs({ page = 1, pageSize = 10 }) {
    let res = await Fetch.get(`${this._url}/devices-config-logs?page=${page}&itemsPerPage=${pageSize}`);

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return {
        logs: res.items,
        totalItems: res.totalItems,
      };
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getActiveDevices({ page = 1, pageSize = 100 }) {
    let res = await Fetch.get(`${this._url}/devices-config?page=${page}&itemsPerPage=${pageSize}`);

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return {
        devices: res.items,
        totalItems: res.totalItems,
      };
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async updateDevicesConfig(payload) {
    let res = await Fetch.post(`${this._url}/update-devices-config`, payload);

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async updateDevicesConfigById(id, payload) {
    let res = await Fetch.put(`${this._url}/update-devices-config/${id}`, payload);

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};

export default devicesConfigService;
